// "Copy link" in a detail's menu: the one row every "…" puts in, so the way a
// link is made and the result is told are the same everywhere (Case, step,
// Person, document, Topic, DM).
//
// Promise: the link is this origin plus the path of the thing (what the screen
// is showing, without view state such as full width), so whoever opens it sees
// the same thing. Writing to the clipboard leaves nothing on the screen, so
// both success and failure are told in a toast (some places, such as plain
// http on a LAN, have no clipboard at all).
import { m } from "@trameria/i18n";
import type { MenuItem } from "../ui/menu";
import { toast } from "../ui/toast";

/** Writes `text` to the clipboard and tells how it went. */
export function copyText(text: string): Promise<boolean> {
  const clipboard =
    typeof navigator === "undefined" ? undefined : navigator.clipboard;
  if (!clipboard) {
    toast(m.shell_copy_failed());
    return Promise.resolve(false);
  }
  return clipboard.writeText(text).then(
    () => {
      toast(m.shell_copied());
      return true;
    },
    () => {
      toast(m.shell_copy_failed());
      return false;
    },
  );
}

/** The full URL of a path in this app (`/me/cases/<id>`). */
export const linkTo = (path: string): string =>
  new URL(path, window.location.origin).href;

/**
 * The "Copy link" row of a menu. `path` is what the link opens; by default the
 * screen's own path (the search and hash are view state, not the thing).
 */
export function copyLinkItem(path?: string): MenuItem {
  return {
    id: "copy-link",
    label: m.shell_copy_link(),
    onSelect: () => void copyText(linkTo(path ?? window.location.pathname)),
  };
}
